/**
 * Format a single answer for display or export.
 */
export function formatAnswerValue(a) {
  if (a.selected_labels && a.selected_labels.length > 0) {
    // Semicolon delimiter matches the SDA import convention for multi-select
    // answers (option labels may themselves contain commas).
    return a.selected_labels.join('; ');
  }
  const t = (a.value_text ?? '').trim();
  if (!t) return '';
  // Likert matrix fallback: the server normally resolves these to
  // selected_labels ("Row: Point"), but format raw keys if one slips through.
  if (t.startsWith('{') && t.includes('"rows"')) {
    try {
      const j = JSON.parse(t);
      if (j.rows && typeof j.rows === 'object') {
        return Object.entries(j.rows)
          .map(([rk, pk]) => `${rk}: ${pk}`)
          .join('; ');
      }
    } catch {
      /* ignore */
    }
  }
  if (t.startsWith('{') && t.includes('"v"')) {
    try {
      const j = JSON.parse(t);
      let out = j.v ?? t;
      if (j.r) out += ` — ${j.r}`;
      if (Array.isArray(j.s) && j.s.length) out += ` [${j.s.join('; ')}]`;
      if (j.o) out += ` (other: ${j.o})`;
      return out;
    } catch {
      /* ignore */
    }
  }
  return t;
}

/**
 * One-line summary of the share-link location a response came from,
 * e.g. "Cafeteria · Prestige Saphire, Floor 2 · Bangalore, India".
 * Returns '' when the response came from the plain (no-location) link.
 */
export function formatResponseLocation(loc) {
  if (!loc) return '';
  const building = [loc.building, loc.floor ? `Floor ${loc.floor}` : ''].filter(Boolean).join(', ');
  const place = [loc.city, loc.country].filter(Boolean).join(', ');
  return [loc.facility, building, place].filter(Boolean).join(' · ');
}

/**
 * Stable question column order across all responses in a export batch.
 */
export function collectQuestionColumns(responses) {
  const keys = [];
  const labels = new Map();
  for (const r of responses) {
    for (const a of r.answers ?? []) {
      if (!labels.has(a.question_key)) {
        keys.push(a.question_key);
        labels.set(a.question_key, a.question_label);
      }
    }
  }
  return { keys, labels };
}
